module.exports = __webpack_public_path__ + "static/media/APP_Scientist_152x174_3.47b9d3e7.png";